import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../core/actions/actions';
import { reset } from 'redux-form';
 
import userSettingEnum from '../../constants/userSetting.enum';
import IState from '../../core/models/IState';
import { toast } from 'react-toastify';
import IAQChartSettingForm from './components/IAQChartSettingForm';
import { formatMessage } from '../../translations/connectedIntlProvider';

const IAQChartSetting = (props: any) => {
  // console.log("ARIF:");
  // console.log( props.isTillDate);
  const { addColumn }: any = useSelector((state: IState) => { return state.column });
  const [values, setValues] = useState<any>();
  const dispatch = useDispatch();

  const onSubmitForm =  (values: any) => {
    if(values){
      setValues(values);
        //dispatch(actions.resetDataRangeState());
        dispatch(actions.addUserSetting(JSON.stringify(values), userSettingEnum.DataRangeIAQ));
        //props.onDataSave(values);
    }
    
   // onModalClosed();
  }

  const onModalClosed = () => {
    dispatch(actions.resetUsersettingAddState());
    dispatch(reset('IAQChartSettingForm'));
    props.modalClosed();
  }

  useEffect(() => {
    if (addColumn.success) {
      onModalClosed();
      props.onDataSave(values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addColumn.success])

  useEffect(() => {
    if (addColumn.error != null)
      toast.error(formatMessage(addColumn.error));
  }, [addColumn.error]);
  
  return (
    <React.Fragment>
      <IAQChartSettingForm
        range={props.range}
        EndDate={props.EndDate}
        isTillDate={props.isTillDate}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
      />
    </React.Fragment>
  );
};

export default IAQChartSetting;
